/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "bills": {
            "nested": {
              "TranslatedName": {
                "fields": {
                  "localizedName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.TranslatedName) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE TranslatedName @ squareup/client/bills/translated_name.proto at 14:1
 */
export const TranslatedName = $root.lookupType('squareup.client.bills.TranslatedName');
fixType(TranslatedName, {
  localizedName: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TranslatedName);